export function isExternalLink(href: string): boolean {
  return typeof href === 'string' && (href.indexOf('http') === 0 || href.indexOf('mailto:') === 0);
}
